import { render } from "./DrawerHeader.vue?vue&type=template&id=cabc26d8&scoped=true"
import script from "./DrawerHeader.vue?vue&type=script&lang=js"
export * from "./DrawerHeader.vue?vue&type=script&lang=js"

import "./DrawerHeader.vue?vue&type=style&index=0&id=cabc26d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cabc26d8"]])

export default __exports__